import React from 'react';
import { CircularProgress } from '@mui/material';

export const LoadingSpinnerOverlay: React.FC<{ size?: number; children?: React.ReactNode }> = ({
  size = 64,
  children,
}) => {
  return (
    <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center">
      <div className="w-full h-full z-40 opacity-60 bg-white"></div>
      <CircularProgress size={size} className="absolute z-50"></CircularProgress>
      {children && <div className="absolute z-50">{children}</div>}
    </div>
  );
};
